import React, { FC } from 'react';
import { IImageCta } from '../../interfaces/umbracoNodes/contentSlices';
import SVGIcon from '../base/SVGIcon';
import { ContentContainer, ContentContainerCard } from '../base/contentContainer/contentContainer';
import { Column } from '../base/grid';
import RichTextTitle from '../base/richTextTitle';
import { A } from '../base/typography';
import Button from '../button-v2';
import * as StyledImageCta from './imageCta.styles';

interface Props {
	content: IImageCta;
}

const ImageCta: FC<Props> = ({ content }) => {
	return (
		<StyledImageCta.ImageCtaWrapper>
			{content.Values.DisplayAsCard && (
				<StyledImageCta.CardContainerWrapper>
					<ContentContainerCard>
						<StyledImageCta.ColumnsStyled imageOnLeft={content.Values.ImageOnLeft}>
							<Column desktopSmall={1 / 2} desktopLarge={5 / 12} marginBottom={0}>
								<StyledImageCta.TextWrapper>
									<RichTextTitle content={content.Values.Title} />
									<StyledImageCta.DescriptionRichText content={content.Values.Description} />
									{content.Values.Button && (
										<StyledImageCta.ButtonWrapper>
											<Button
												title={content.Values.Button.Name}
												href={content.Values.Button.Url}
												target={content.Values.Button.Target}
											/>
										</StyledImageCta.ButtonWrapper>
									)}
								</StyledImageCta.TextWrapper>
							</Column>
							<Column desktopSmall={1 / 2} marginBottom={0}>
								<StyledImageCta.CardImageWrapper imageOnLeft={content.Values.ImageOnLeft}>
									{content.Values.Image && (
										<StyledImageCta.CardImage
											src={content.Values.Image.Src}
											sizes="(max-width: 700px), (max-height: 680px)"
										/>
									)}
								</StyledImageCta.CardImageWrapper>
							</Column>
						</StyledImageCta.ColumnsStyled>
					</ContentContainerCard>
				</StyledImageCta.CardContainerWrapper>
			)}
			{!content.Values.DisplayAsCard && (
				<ContentContainer>
					<StyledImageCta.ColumnsStyled
						smallIconAvailable={content.Values.SmallImageIcon && content.Values.SmallImageIconLink}
						imageOnLeft={content.Values.ImageOnLeft}>
						<Column desktopSmall={1 / 2} desktopLarge={5 / 12} marginBottom={0}>
							<StyledImageCta.TextWrapper>
								<RichTextTitle content={content.Values.Title} />
								<StyledImageCta.DescriptionRichText content={content.Values.Description} />
								{content.Values.Button && (
									<StyledImageCta.ButtonWrapper>
										<Button
											title={content.Values.Button.Name}
											href={content.Values.Button.Url}
											target={content.Values.Button.Target}
										/>
									</StyledImageCta.ButtonWrapper>
								)}
							</StyledImageCta.TextWrapper>
						</Column>
						<Column desktopSmall={1 / 2} marginBottom={0}>
							<StyledImageCta.ColumnImageWrapper>
								<StyledImageCta.ImageWrapper>
									{content.Values.Image && (
										<StyledImageCta.NonCardImage
											src={content.Values.Image.Src}
											sizes="(max-width: 700px), (max-height: 680px)"
										/>
									)}
									{content.Values.SmallImageIcon && content.Values.SmallImageIconLink && (
										<A
											to={content.Values.SmallImageIconLink.Url}
											target={content.Values.SmallImageIconLink.Target}>
											<StyledImageCta.SmallImageWrapper>
												<SVGIcon icon={content.Values.SmallImageIcon} preserveDimensions />
											</StyledImageCta.SmallImageWrapper>
										</A>
									)}
								</StyledImageCta.ImageWrapper>
							</StyledImageCta.ColumnImageWrapper>
						</Column>
					</StyledImageCta.ColumnsStyled>
				</ContentContainer>
			)}
		</StyledImageCta.ImageCtaWrapper>
	);
};

export default ImageCta;
